// extracted by mini-css-extract-plugin
export default {"container":"style_container__KDhMb","actual":"style_actual__-+my5"};